export default __webpack_public_path__ + "assets/5.b278d271.png";